<template>
  <main>
    <div class="courses-all" v-if="category">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/courses">{{ $t("all_courses") }}</router-link>
          </li>
        </ul>
        <div class="page-sub-title">
          <h1>
            <i class="fa-title"></i><i>{{ $t("all_courses") }}</i>
          </h1>
        </div>
        <div class="courses-all-frame">
          <div class="courses-category" v-if="category">
            <div class="courses-category-title" @click="categoryMobile">
              <i class="fa-category-square"></i>
              <h3>{{ $t("course_categories") }}</h3>
            </div>
            <transition v-on:enter="enter" v-on:leave="leave">
              <div class="courses-category-list" v-show="category_open">
                <div
                  class="courses-category-item"
                  v-for="item in category"
                  :key="item.id"
                >
                  <h4
                    @click="openItem(item)"
                    :class="{ 'courses-active': item.is_open }"
                  >
                    <div>{{ item.title }}</div>
                    <i class="fa-arrow-next"></i>
                  </h4>
                  <transition v-on:enter="enter" v-on:leave="leave">
                    <ul v-if="item.children.length" v-show="item.is_open">
                      <li v-for="itm in item.children" :key="itm.id">
                        <a href="#" @click.prevent="CoursesById(itm.id)">{{
                          itm.title
                        }}</a>
                      </li>
                    </ul>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
          <div class="courses-all-box" v-if="courses">
            <div class="courses-all-list">
              <CoursesCard
                v-for="item in courses.result"
                :key="item.id"
                :data="item"
                :finish="true"
              />
            </div>
            <template v-if="loading">
              <a
                href="#"
                v-if="!(courses.last_page === courses.page)"
                class="courses-all-hide"
              >
                <img src="../../assets/images/status/load.svg" alt="" />
              </a>
            </template>
            <template v-else>
              <a
                href="#"
                v-if="!(courses.last_page === courses.page)"
                @click.prevent.stop="paginationCourse"
                class="courses-all-hide"
              >
                <div>{{ $t("more_courses") }}</div>
                <i class="fa-arrow-line"></i>
              </a>
            </template>
          </div>
          <div v-else class="courses-all-box">
            <v-loader />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CoursesCard from "@/components/CoursesCard";
import Velocity from "velocity-animate";

export default {
  data() {
    return {
      category_open: true,
      queryPath: {},
      loading: false,
    };
  },
  async mounted() {
    if (window.innerWidth <= 700) {
      this.category_open = !this.category_open;
    }
    await this.$store.dispatch("getCategory");
    await this.$store.dispatch("getCourses");
    if (this.category) {
      this.category.map((e) => {
        if (+e.id === +this.$route.query.cat_id) {
          e.is_open = true;
        }
        e.children.map((el) => {
          if (+el.id === +this.$route.query.cat_id) {
            e.is_open = true;
          }
        });
      });
    }
  },
  methods: {
    async openItem(item) {
      this.category.map((e) => {
        if (!(item.id === e.id)) {
          e.is_open = false;
        }
      });
      item.is_open = !item.is_open;
      if (item.is_open) {
        await this.$store.dispatch("getCoursesById", item.id);
        this.queryPath.cat_id = item.id;
        this.replaceUrl();
      } else {
        this.queryPath.cat_id = null;
        this.replaceUrl();
        await this.$store.dispatch("getCourses");
      }
    },

    setClass(item) {
      if (item.is_open === true) {
        return "open";
      }
      return "close";
    },

    enter: function (el, done) {
      Velocity(
        el,
        "slideDown",
        {
          duration: 200,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },

    leave: function (el, done) {
      Velocity(
        el,
        "slideUp",
        {
          duration: 200,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },

    categoryMobile() {
      if (window.innerWidth <= 700) {
        this.category_open = !this.category_open;
      }
    },

    async CoursesById(id) {
      this.queryPath.cat_id = id;

      await this.$store.dispatch("getCoursesById", id);
      this.replaceUrl();
    },
    replaceUrl() {
      if (this.queryPath.cat_id) {
        history.replaceState(null, null, "?" + this.serialize(this.queryPath));
      } else {
        console.log("null");
        history.replaceState(null, null, "?");
      }
    },

    serialize(obj) {
      let str = [];
      for (let p in obj) str.push(encodeURIComponent(p) + "=" + obj[p]);
      return str.join("&");
    },
    async paginationCourse() {
      this.loading = true;
      await this.$store.dispatch("paginationCourses", this.courses.page + 1);
      this.loading = false;
    },
  },
  computed: {
    category() {
      return this.$store.getters.getCategory;
    },
    courses() {
      return this.$store.getters.getCourses;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
  components: {
    CoursesCard,
  },
};
</script>
